import React, { useState } from 'react';
import './Cart.css';

export default function Cart({ cart, defaultTable = '', onUpdateQuantity, onClose, onOrderSubmit, order }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const total = cart.reduce((sum, c) => sum + c.price * c.quantity, 0);

  const handleSubmit = async () => {
    if (!defaultTable.trim()) { setError('未指定桌號，請重新掃描 QR Code'); return; }
    if (cart.length === 0) { setError('購物車為空'); return; }

    setSubmitting(true);
    setError('');

    try {
      await onOrderSubmit(cart);
      onClose();
    } catch (e) {
      setError(e.message || '送出訂單失敗');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="cart-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="cart-panel">
        <div className="cart-header">
          <h2>{defaultTable && <span className={`cart-table${defaultTable === 'out' ? ' cart-table-out' : ''}`}>{defaultTable === 'out' ? `外帶${order?.takeout_seq ? ` #${order.takeout_seq}` : ''} ・` : `桌號 ${defaultTable} ・`}</span>}訂單明細 {cart.length > 0 && <span className="cart-count">({cart.reduce((s,c)=>s+c.quantity,0)}項)</span>}</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        {cart.length === 0 ? (
          <div className="cart-empty">
            <p>🛒 購物車是空的</p>
            <p className="cart-empty-sub">請從菜單選擇餐點</p>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {cart.map(item => (
                <div key={item.cartKey} className="cart-item">
                  <div className="cart-item-info">
                    <span className="cart-item-name">{item.displayName}</span>
                    <span className="cart-item-unit">${item.price} / 份</span>
                  </div>
                  <div className="cart-qty-ctrl">
                    <button onClick={() => onUpdateQuantity(item.cartKey, -1)}>−</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => onUpdateQuantity(item.cartKey, 1)}>+</button>
                  </div>
                  <span className="cart-subtotal">
                    ${(item.price * item.quantity).toLocaleString()}
                  </span>
                </div>
              ))}
            </div>

            <div className="cart-total">
              <span>合計</span>
              <span className="total-amt">${total.toLocaleString()}</span>
            </div>
          </>
        )}

        {error && <p className="cart-error">{error}</p>}

        <button
          className="order-btn"
          onClick={handleSubmit}
          disabled={submitting || cart.length === 0}
        >
          {submitting ? (order ? '更新中...' : '送出中...') : (order ? '更新點單' : '送出訂單')}
        </button>
      </div>
    </div>
  );
}
